import React, { useState } from 'react'
import { ChatIcon } from '@heroicons/react/outline'
import { useGlobalState } from '@/state'
import useQuery from '@/hooks/useQuery'

const SocialPostForm = ({ onPostCreated }) => {
  const [content, setContent] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [currentUser] = useGlobalState('currentUser')
  const { putpostRequest } = useQuery()

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!content.trim() || isSubmitting) return

    setIsSubmitting(true)
    
    putpostRequest(`/api/v3/social_posts`, 'POST', {
      social_post: { content: content.trim() }
    }, (err, jsonData) => {
      setIsSubmitting(false)
      if (err) return
      
      setContent('')
      if (onPostCreated) onPostCreated(jsonData)
    })
  }

  const remainingChars = 500 - content.length

  return (
    <div className="border-b border-gray-200 dark:border-gray-700 pb-4 mb-6">
      <form onSubmit={handleSubmit}>
        <div className="flex space-x-3">
          <div className="flex-shrink-0">
            <img
              className="h-10 w-10 rounded-full"
              src={currentUser.avatarUrl}
              alt={currentUser.displayName}
            />
          </div>
          <div className="min-w-0 flex-1">
            <div>
              <textarea
                rows={3}
                value={content}
                onChange={(e) => setContent(e.target.value)}
                className="block w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm placeholder-gray-400 dark:placeholder-gray-500 focus:ring-cccblue focus:border-cccblue dark:bg-gray-800 dark:text-white sm:text-sm resize-none"
                placeholder="Update people on what you're up to these days. Or share something interesting you found."
                maxLength={500}
                disabled={isSubmitting}
              />
            </div>
            <div className="mt-3 flex items-center justify-between">
              <div className="flex space-x-5">
                <span className={`text-sm ${remainingChars < 50 ? (remainingChars < 0 ? 'text-red-500' : 'text-yellow-500') : 'text-gray-500 dark:text-gray-400'}`}>
                  {remainingChars} characters remaining
                </span>
              </div>
              <button
                type="submit"
                disabled={!content.trim() || isSubmitting || remainingChars < 0}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-cccblue hover:bg-cccblue-alt focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cccblue disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <ChatIcon className="-ml-1 mr-2 h-4 w-4" />
                {isSubmitting ? 'Posting...' : 'Post'}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default SocialPostForm
